export default "__VITE_ASSET__9467688c__"